import mildHearingSideImage from '@/components/results-category/images/mild-hearing-side-image.webp';
import mildHearingIcon from '@/components/results-category/images/mild-hearing-icon.webp';
import normalHearingSideImage from '@/components/results-category/images/normal-hearing-side-image.webp';
import normalHearingIcon from '@/components/results-category/images/normal-hearing-icon.webp';
import severeHearingSideImage from '@/components/results-category/images/severe-hearing-side-image.webp';
import severeHearingIcon from '@/components/results-category/images/severe-hearing-icon.webp';
import { palette } from '@/theme/palette';
export var resultCategoryImages = {
    mildHearingSideImage: mildHearingSideImage,
    mildHearingIcon: mildHearingIcon,
    normalHearingSideImage: normalHearingSideImage,
    normalHearingIcon: normalHearingIcon,
    severeHearingSideImage: severeHearingSideImage,
    severeHearingIcon: severeHearingIcon,
};
export var severeCategory = {
    name: 'Severe Hearing Difficulties',
    icon: severeHearingIcon,
    emphasizedText: 'significant hearing difficulties',
    textColor: palette.custom.moderateCategory.main,
};
export var mildCategory = {
    name: 'Mild Hearing Difficulties',
    icon: mildHearingIcon,
    emphasizedText: 'hearing difficulties',
    textColor: palette.custom.mildCategory.main,
};
export var normalCategory = {
    name: 'OK Hearing',
    icon: normalHearingIcon,
    emphasizedText: 'ok hearing',
    textColor: palette.custom.normalCategory.main,
};
